import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CandidateList } from './candidate-list';
import { Typography } from 'antd';
import { FontSize } from '@common/tokens';

const { Title } = Typography;

const filterOffersByStates = (items, states) =>
  items.filter((item) => {
    const { state } = item.activeOffer;
    return states.includes(state);
  });

export function OffersCandidateList({ items, emptyText, staffingRequest }) {
  const activeOffers = useMemo(
    () => filterOffersByStates(items, ['offered', 'change_requested']),
    [items]
  );

  const inactiveOffers = useMemo(
    () => filterOffersByStates(items, ['rejected']),
    [items]
  );

  if (activeOffers.length === 0 && inactiveOffers.length === 0) {
    return <CandidateList items={[]} emptyText={emptyText} />;
  }

  return (
    <div className="OffersCandidateList">
      {activeOffers.length > 0 && (
        <>
          <Title className="CandidateListTitle" level={3}>
            Active
          </Title>
          <CandidateList
            items={activeOffers}
            emptyText={emptyText}
            staffingRequest={staffingRequest}
          />
        </>
      )}

      {inactiveOffers.length > 0 && (
        <>
          <Title className="CandidateListTitle" level={3}>
            Inactive
          </Title>
          <CandidateList
            items={inactiveOffers}
            emptyText={emptyText}
            staffingRequest={staffingRequest}
          />
        </>
      )}
      <style jsx>
        {`
          :global(.OffersCandidateList .CandidateListTitle) {
            margin-top: 32px;
            margin-bottom: 0;
            margin-left: 24px;
            font-size: ${FontSize.xl};
          }
        `}
      </style>
    </div>
  );
}

OffersCandidateList.propTypes = {
  items: PropTypes.array,
  emptyText: PropTypes.string,
  staffingRequest: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};
